/*
 * Copyright (c) 2020, Neustar, Inc.
 * UNPUBLISHED PROPRIETARY SOURCE CODE
 *
 */

import React from 'react';
import ErrorModal from '../components/ErrorModal';

function Loading({ error, isSpinner = false, spinnerStyles = {} }) {
  if (error) {
    return <ErrorModal />;
  } else if (isSpinner) {
    return <div className="unit-loading-spinner" style={{...spinnerStyles}}>
      <div className="spinner-border" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  } else {
    return <h3>Loading...</h3>;
  }
}

export default Loading;